import { call } from '@advanza/api'
import { changeEntity } from 'actions/entities'
import { _changeFilter, _fetchItems } from 'actions/lists'
import { localToUTC } from 'date'
import { AppThunkAction } from 'hooks/hooks'
import reviewsSchema from '../schemes/reviewsSchema'

export const REVIEWS_RECEIVE_LIST = 'REVIEWS_RECEIVE_LIST'
export const REVIEWS_CHANGE_FILTER = 'REVIEWS_CHANGE_FILTER'
export const REVIEWS_REQUEST = 'REVIEWS_REQUEST'

export function fetchReviews(filterId: string) {
    return _fetchItems(filterId, {
        url: 'office/reviews/get-list',
        schema: reviewsSchema,
        requestActionName: REVIEWS_REQUEST,
        receiveActionName: REVIEWS_RECEIVE_LIST,
        reducerKey: 'reviews',
    })
}

export function changeReviewsFilter(filterId: string, options: Record<string, unknown>) {
    return _changeFilter(filterId, options, {
        reducerKey: 'reviews',
        fetchFunc: fetchReviews,
        actionType: REVIEWS_CHANGE_FILTER,
    })
}

export function saveReview(reviewId: string | number): AppThunkAction<Promise<unknown>> {
    return (dispatch, getState) => {
        const { reviews } = getState().reviews.entities
        const review = reviews[reviewId as keyof typeof reviews]
        const isNew = typeof reviewId === 'string'
        const payload = { ...review }
        if (
            !isNew &&
            (payload.created === null || payload.created === undefined || payload.created === '')
        ) {
            delete payload.created
        }
        return call(`office/reviews/save/${isNew ? 0 : reviewId}`, { json: payload }).then(() => {
            if (isNew) {
                dispatch({ type: 'INVALIDATE_REVIEWS' })
            }
        })
    }
}

export function addReview(
    options: Record<string, unknown>,
    filterId: string,
): AppThunkAction<void> {
    return (dispatch) => {
        const newReviewId = Math.random().toString(36).substr(2, 5)
        dispatch(
            changeEntity({
                diff: {
                    review_id: newReviewId,
                    _open: true,
                    created: localToUTC(new Date()),
                    status: 1,
                    ...options,
                },
                key: newReviewId,
                filterId,
                name: 'reviews',
                store: 'reviews',
                remove: undefined,
                newKey: undefined,
                dontTouch: undefined,
                preservePreviousTouch: undefined,
            }),
        )
    }
}

function deleteReview(reviewId: string | number): AppThunkAction<Promise<unknown>> {
    return (dispatch) => {
        const isNew = typeof reviewId === 'string'
        const removeFromStore = () => {
            dispatch(
                changeEntity({
                    store: 'reviews',
                    name: 'reviews',
                    remove: true,
                    key: reviewId,
                    filterId: undefined,
                    diff: undefined,
                    newKey: undefined,
                    dontTouch: undefined,
                    preservePreviousTouch: undefined,
                }),
            )
        }
        if (isNew) {
            return Promise.resolve(removeFromStore())
        }
        return call(`office/reviews/delete/${reviewId}`, { method: 'post' }).then(removeFromStore)
    }
}

export function deleteReviewSelection(filterId: string): AppThunkAction<Promise<unknown>> {
    return (dispatch, getState) => {
        const selection = getState().reviews.filters[filterId].selection
        const promises = selection.map((reviewId: string | number) =>
            dispatch(deleteReview(reviewId)),
        )
        return Promise.all(promises).then(() => {
            dispatch(changeReviewsFilter(filterId, { selection: [] }))
        })
    }
}
